import { ChangeDetectorRef, EventEmitter, OnInit } from '@angular/core';
import { Category, Data, InventoryManager, Item, MenuManager, OrderManager } from 'aigens-ng-core';
import { OrderService } from '../../core/services/order.service';
import { SystemConfigService } from 'src/app/core/services/systemConfig.service';
import { TranslateService } from '@ngx-translate/core';
var GridLayoutItemDouble = /** @class */ (function () {
    // tslint:disable-next-line: max-line-length
    function GridLayoutItemDouble(cdr, translateService, inventoryManager, orderService, menuManager, systemConfigService) {
        this.cdr = cdr;
        this.translateService = translateService;
        this.inventoryManager = inventoryManager;
        this.orderService = orderService;
        this.menuManager = menuManager;
        this.systemConfigService = systemConfigService;
        this.urls = [];
        this.itemName = [];
        this.isSoldout = [];
        this.isSet = [];
        this.addClick = new EventEmitter();
        this.removeClick = new EventEmitter();
        this.isShowLogo = true; // control the cat-item list-mode when img is null then if show the logo
        this.settings = this.orderService.getCurrentStoreSetting();
        // todo init the isShowLogo
        this.isShowLogo = this.systemConfigService['systemConfig'] && this.systemConfigService['systemConfig']['data'] && this.systemConfigService['systemConfig']['data']['showLogo'];
        console.log('isShowLogo:', this.isShowLogo);
    }
    Object.defineProperty(GridLayoutItemDouble.prototype, "items", {
        set: function (input) {
            this._items = input;
            var tempUrls = [];
            var tempItemName = [];
            var tempIsSoldout = [];
            var tempIsSet = [];
            for (var _i = 0, _a = this._items; _i < _a.length; _i++) {
                var item = _a[_i];
                var temp = this.getItemImage(item);
                tempUrls.push("url(" + temp + ")");
                tempItemName.push(this.getItemName(item));
                var now = Date.now();
                if (this._category) {
                    tempIsSoldout.push(this.getSoldout(item, now));
                    tempIsSet.push(this.getIsSet(item));
                }
            }
            this.urls = tempUrls;
            this.itemName = tempItemName;
            if (this._category)
                this.isSoldout = tempIsSoldout;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GridLayoutItemDouble.prototype, "category", {
        set: function (input) {
            this._category = input;
            this.mode = this._category && this._category.layout && this._category.layout !== 'none' ? this._category.layout : this.settings.itemLayout;
            if (this._category && this._items && this._items.length > 0) {
                var tempIsSoldout = [];
                var tempIsSet = [];
                var now = Date.now();
                for (var _i = 0, _a = this._items; _i < _a.length; _i++) {
                    var item = _a[_i];
                    tempIsSoldout.push(this.getSoldout(item, now));
                    tempIsSet.push(this.getIsSet(item));
                }
                this.isSoldout = tempIsSoldout;
                this.isSet = tempIsSet;
            }
        },
        enumerable: true,
        configurable: true
    });
    GridLayoutItemDouble.prototype.ngOnInit = function () {
    };
    GridLayoutItemDouble.prototype.getIsSet = function (item) {
        return Item.isSet(this._category, item);
    };
    GridLayoutItemDouble.prototype.getItemName = function (item) {
        var name = item.name;
        if (!!(item.variations && item.variations.length > 0)) {
            name = item.title;
        }
        if (!name || name.length === 0) {
            name = item.name;
        }
        return name;
    };
    GridLayoutItemDouble.prototype.getItemImage = function (item) {
        var url;
        if (item.featured) {
            if (item.images && item.images['hero'] && item.images['hero']['url'])
                url = item.images['hero']['url'];
        }
        else {
            url = Data.getImage(item, 'default', 150, true);
        }
        return url || this.defaultImage;
    };
    GridLayoutItemDouble.prototype.getItemImageWithoutDefault = function (item) {
        var url;
        if (item.featured) {
            if (item.images && item.images['hero'] && item.images['hero']['url'])
                url = item.images['hero']['url'];
        }
        else {
            url = Data.getImage(item, 'default', 150, true);
        }
        return url;
    };
    GridLayoutItemDouble.prototype.getSoldout = function (item, now) {
        var result;
        var imSoldout = this.inventoryManager.isSoldout(item);
        result = (!(!!(item.variations && item.variations.length > 0)) && imSoldout);
        return result || !this.menuManager.isAvailableCombo(this.orderManager.store, this._category, item, this.orderManager.isTakeout(), now);
    };
    GridLayoutItemDouble.prototype.removeClicked = function (item) {
        var _this = this;
        this.removeClick.emit({
            item: item, callBack: function () {
                _this.cdr.detectChanges();
            }
        });
    };
    GridLayoutItemDouble.prototype.addClicked = function (item) {
        var _this = this;
        this.addClick.emit({
            item: item, callBack: function () {
                _this.cdr.detectChanges();
            }
        });
    };
    return GridLayoutItemDouble;
}());
export { GridLayoutItemDouble };
